// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"c8aab1dc","209":"32193747","298":"67bf0bcb","392":"204be4c9","478":"84ae3282","552":"e46390a3","562":"5b6a520a","615":"a07cb5d3","787":"39d8c6a5","922":"afbbcce7","964":"088fa653"}[chunkId] + ".chunk.js";
};